import { Hosts } from '~helpers/environments';

const environment = '';

export const cdnHost = () => {
  return Hosts.cdnUrl;
};

export const url = () => {
  return Hosts.hostUrl;
};

export const GRAPH_URL = url();
export const graphqlURL = url();

export const authUrl = link => {
  return Hosts.authUrl + link;
};

const authImageUrl = link => {
  return Hosts.authImageUrl + link;
};

const cmsFacadeEnvUrl = link => {
  return `${Hosts.facadeUrl}${link}`;
};

const imageUrl = link => {
  return Hosts.imageUrl + link;
};

const pdfUrl = link => {
  return Hosts.fileCdnUrl + link;
};

const endpoints = {
  login: {
    isSecure: true,
    url: () => url(`/${environment}ajax/users/login`),
  },
  resetPassword: {
    isSecure: true,
    url: () => url(),
  },
  setPassword: {
    isSecure: true,
    url: () => url(),
  },
  clientInfo: {
    isSecure: true,
    url: () => `/${environment}ajax/get-client-info`,
  },
  getPropertyList: {
    isSecure: true,
    url: () => `/${environment}ajax/properties`,
  },
  getStripeClientId: {
    isSecure: true,
    url: currency => `/${environment}ajax/stripe/${currency}/client-id`,
  },
  getBookingList: {
    isSecure: true,
    url: () => `/${environment}ajax/bookings`,
  },
  getBookingDetail: {
    isSecure: true,
    url: bookingId => `/${environment}ajax/bookings/${bookingId}`,
  },
  getBookingSummary: {
    isSecure: true,
    url: () => `/${environment}ajax/bookings/summary`,
  },
  updateBookingStatus: {
    isSecure: true,
    url: () => `/${environment}ajax/bookings`,
  },
  updateBookingComment: {
    isSecure: true,
    url: bookingId => `/${environment}ajax/bookings/${bookingId}/comments`,
  },
  graphql: {
    isSecure: true,
    url: () => url(),
  },
  checkLandlordAccountExist: {
    isSecure: true,
    url: () => url(),
  },
  getWithdrawalMethods: {
    isSecure: true,
    url: () => url('/api/withdrawal/list'),
  },
  updateWithdrawalMethod: {
    isSecure: true,
    url: () => url('/api/withdrawal/update'),
  },
  deleteWithdrawalMethod: {
    isSecure: true,
    url: () => url('/api/withdrawal/delete'),
  },
  addWithdrawalMethod: {
    isSecure: true,
    url: () => url('/api/withdrawal/add'),
  },
  getStripeId: {
    isSecure: true,
    url: () => url('/api/withdrawal/get-stripe-id'),
  },
  search: {
    isSecure: true,
    url: type => url(type ? `/api/properties/search/${type}` : '/api/properties/search/list'),
  },
};

export const pmsEndpoints = {
  defaultUrl: {
    isSecure: true,
    url: () => url(),
  },

  login: {
    isSecure: true,
    url: () => url(),
  },

  forgotPassword: {
    isSecure: true,
    url: () => authUrl('/microapp-student-portal/ajax/forgot/password'),
  },

  setPassword: {
    isSecure: true,
    url: () => authUrl('/microapp-student-portal/ajax/reset/password'),
  },

  checkUserExist: {
    isSecure: true,
    url: () => url(),
  },

  getPropertyList: {
    isSecure: true,
    url: () => url('/api/properties/properties/list'),
  },

  getSpecialOfferList: {
    isSecure: true,
    url: () => url(),
  },

  deleteSpecialOffer: {
    isSecure: true,
    url: () => url(),
  },

  getDistinctions: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/list'),
  },

  createDistinction: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/create'),
  },

  updateDistinction: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/update'),
  },

  deleteDistinction: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/delete'),
  },

  removeDistinctionFromUnitType: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/remove-distinction'),
  },

  addDistinctionToUnitType: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/add-distinction'),
  },

  createRoomList: {
    isSecure: true,
    url: () => url('/api/properties/listing/create-listing'),
  },

  updateRoomList: {
    isSecure: true,
    url: () => url('/api/properties/listing/update-listing'),
  },

  deleteRoomList: {
    isSecure: true,
    url: () => url('/api/properties/listing/remove-listing'),
  },

  getClassifications: {
    isSecure: true,
    url: () => url('/api/properties/classifications/list'),
  },

  updateClassification: {
    isSecure: true,
    url: () => url('/api/properties/classifications/update'),
  },

  createClassification: {
    isSecure: true,
    url: () => url('/api/properties/classifications/create'),
  },

  deleteClassification: {
    isSecure: true,
    url: () => url('/api/properties/classifications/delete'),
  },

  removeClassificationFromUnitType: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/remove-classification'),
  },

  addClassificationToUnitType: {
    isSecure: true,
    url: () => url('/api/properties/distinctions/add-classification'),
  },

  search: {
    isSecure: true,
    url: type => url(type ? `/api/properties/search/${type}` : '/api/properties/search/list'),
  },

  exportList: {
    isSecure: true,
    url: landlordSlug => `/service/nomination-list/download?landlord=${landlordSlug}`,
  },

  uploadList: {
    isSecure: true,
    url: landlordSlug => `/service/nomination-list/upload/${landlordSlug}`,
  },

  getStudentDetail: {
    isSecure: true,
    url: () => url('/api/udesk/student-detail'),
  },

  getPropertyDetail: {
    isSecure: true,
    url: () => url('/api/properties/properties/get-property-detail'),
  },

  updateProperty: {
    isSecure: true,
    url: () => url('/api/properties/properties/update-property'),
  },

  publishProperty: {
    isSecure: true,
    url: () => url('/api/properties/properties/publish-property'),
  },

  uploadImage: {
    isSecure: true,
    url: () => cmsFacadeEnvUrl('/images'),
  },

  uploadPropertyImage: {
    isSecure: true,
    url: () => cmsFacadeEnvUrl('/property_images'),
  },

  image: {
    isSecure: true,
    url: (filename, options) =>
      imageUrl(
        `/${options.type ? `${options.type}_` : ''}${options.width}x${options.height}/${filename}`,
      ),
  },

  pdf: {
    isSecure: true,
    url: (item, prefix) =>
      pdfUrl(`/${prefix}/${item.filename}-${item.imageHash}.${item.extension}`),
  },

  getCountryList: {
    isSecure: true,
    url: () => url(),
  },

  getCityDetail: {
    isSecure: true,
    url: () => url(),
  },

  getCityList: {
    isSecure: true,
    url: () => url(),
  },

  createCity: {
    isSecure: true,
    url: () => url(),
  },

  updateCity: {
    isSecure: true,
    url: () => url(),
  },

  getUniversityDetail: {
    isSecure: true,
    url: () => url(),
  },

  getAreaList: {
    isSecure: true,
    url: () => url(),
  },

  getAreaDetail: {
    isSecure: true,
    url: () => url(),
  },

  updateArea: {
    isSecure: true,
    url: () => url(),
  },

  createArea: {
    isSecure: true,
    url: () => url(),
  },

  getUniversityList: {
    isSecure: true,
    url: () => url(),
  },

  updateUniversity: {
    isSecure: true,
    url: () => url(),
  },

  createUniversity: {
    isSecure: true,
    url: () => url(),
  },

  updateLocationImage: {
    isSecure: true,
    url: () => url(),
  },

  createLocationImage: {
    isSecure: true,
    url: () => url(),
  },

  deletedLocationImage: {
    isSecure: true,
    url: () => url(),
  },
  getUploadVideoToken: {
    isSecure: true,
    url: () => url(),
  },
  checkVideoUploaded: {
    isSecure: true,
    url: () => url(),
  },
  createVideo: {
    isSecure: true,
    url: () => url(),
  },
  createProperty: {
    isSecure: true,
    url: () => url(),
  },
  commissionModal: {
    isSecure: true,
    url: () => url(),
  },

  depositUrl: {
    isSecure: true,
    url: () => url(),
  },

  recordModal: {
    isSecure: true,
    url: () => url(),
  },

  getLandlordProperties: {
    isSecure: true,
    url: () => url(),
  },
  getContractList: {
    isSecure: true,
    url: () => url(),
  },
  createContract: {
    isSecure: true,
    url: () => url(),
  },
  updateContract: {
    isSecure: true,
    url: () => url(),
  },
  deleteContract: {
    isSecure: true,
    url: () => url(),
  },
  updateContractFile: {
    isSecure: true,
    url: () => cmsFacadeEnvUrl('/document'),
  },
  updateCommentFile: {
    isSecure: true,
    url: () => cmsFacadeEnvUrl('/opportunity_pending_note_file'),
  },
  getContractFile: {
    isSecure: true,
    url: () => authImageUrl('apis/v1/properties/contract-img'),
  },
  getDocumentFile: {
    isSecure: true,
    url: () => authImageUrl('apis/v1/properties/requested-document'),
  },
  bulkDuallySigned: {
    isSecure: true,
    url: () => url(),
  },
  getLandlordList: {
    isSecure: true,
    url: () => url(),
  },
  getLandlordUser: {
    isSecure: true,
    url: () => url(),
  },
  getGeneralUrl: {
    isSecure: true,
    url: () => url(),
  },
  getPropertyComments: {
    isSecure: true,
    url: () => url('/api/properties/properties/get-property-comments'),
  },
  requestPublish: {
    isSecure: true,
    url: () => url(),
  },
  updatePropertyDetails: {
    isSecure: true,
    url: () => url(),
  },
  deleteRoom: {
    isSecure: true,
    url: () => url(),
  },
  createRoom: {
    isSecure: true,
    url: () => url(),
  },
  getPropertyTerms: {
    isSecure: true,
    url: () => url(),
  },
  createPropertyTerms: {
    isSecure: true,
    url: () => url(),
  },
  updatePropertyTerms: {
    isSecure: true,
    url: () => url(),
  },
  deletePropertyTerms: {
    isSecure: true,
    url: () => url(),
  },
  uploadTermsFile: {
    isSecure: true,
    url: () => url(),
  },
};

export default endpoints;
